var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"99c2273d524562dd421201958d5c687b5955333b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["blipp-frontend@blipp-ab"]={id:"99c2273d524562dd421201958d5c687b5955333b"};
      